import AppRoutes from './routes'

function App() {


  return (
    <>
      <AppRoutes></AppRoutes>      
    </>
  )
}

export default App
